var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 12C11.0204 12 8.83602 9.67031 8.62508 6.80625C8.51727 5.35312 8.96727 4.00781 9.89071 3.01875C10.8001 2.03906 12.0845 1.5 13.5001 1.5C14.9063 1.5 16.186 2.04375 17.1001 3.02812C18.0282 4.02656 18.4782 5.36719 18.3704 6.80625C18.1595 9.67031 15.9751 12 13.5001 12ZM13.5001 3C12.5063 3 11.611 3.37031 10.9876 4.04062C10.3548 4.72031 10.0454 5.66719 10.1204 6.69844C10.2704 8.76094 11.8173 10.5047 13.4954 10.5047C15.1735 10.5047 16.7204 8.76094 16.8704 6.69844C16.9454 5.68125 16.636 4.73906 15.9938 4.05C15.3751 3.37031 14.4845 3 13.5001 3Z",
    fill: "#434289"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7508 22.5H5.25084C4.80084 22.5 4.39303 22.3125 4.11178 21.975C3.80709 21.6094 3.68521 21.1125 3.77896 20.6109C4.17271 18.4172 5.41021 16.575 7.35084 15.2812C9.07584 14.1328 11.2602 13.5 13.5008 13.5C15.7415 13.5 17.9258 14.1328 19.6508 15.2812C21.5915 16.575 22.829 18.4172 23.2227 20.6109C23.3118 21.1125 23.1899 21.6094 22.8852 21.975C22.604 22.3125 22.2008 22.5 21.7508 22.5ZM5.26021 21H21.7415C21.7508 20.9766 21.7555 20.9391 21.7462 20.8781C21.0196 16.8422 16.9602 15 13.5008 15C10.0415 15 5.98209 16.8422 5.25553 20.8781C5.24615 20.9391 5.25084 20.9766 5.26021 21Z",
    fill: "#434289"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 14.25C3.7125 14.25 3.375 13.9125 3.375 13.5V8.25C3.375 7.8375 3.7125 7.5 4.125 7.5C4.5375 7.5 4.875 7.8375 4.875 8.25V13.5C4.875 13.9125 4.5375 14.25 4.125 14.25Z",
    fill: "#434289"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.625H1.5C1.0875 11.625 0.75 11.2875 0.75 10.875C0.75 10.4625 1.0875 10.125 1.5 10.125H6.75C7.1625 10.125 7.5 10.4625 7.5 10.875C7.5 11.2875 7.1625 11.625 6.75 11.625Z",
    fill: "#434289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlue);
export default __webpack_public_path__ + "static/media/add-blue.ae633f39a1f22cfb30cf6701b302f5af.svg";
export { ForwardRef as ReactComponent };